/**
 * @file Pipe for transforming oid to key
 * @author Tzi Yang Lum
 */
import { PipeTransform } from '@angular/core';
import { DomainService } from '../../domain.service';
/**
 * The class for oid to key
 */
var OidToKeyPipe = /** @class */ (function () {
    function OidToKeyPipe() {
    }
    /**
     * Transform resourceOid to key
    * @param {string} oid The resourceOid in string
    * @returns {number} The key in number
    */
    OidToKeyPipe.prototype.transform = function (oid) {
        var resourceKey = DomainService.oidToKey(oid);
        return resourceKey;
    };
    return OidToKeyPipe;
}());
export { OidToKeyPipe };
